import React, { useEffect, useState } from 'react'
import { useAuth } from '../../context/auth-context';
import axios from 'axios';
import { toast } from 'react-toastify';
import { rootUrl } from '../../helpers';
import DataTable from 'react-data-table-component';
import { FaBook, FaEdit, FaSpinner, FaThumbsUp, FaChartBar } from 'react-icons/fa';
import FormGenerator from '../../components/formGenerator';
import ModalDefault from '../../components/ModalDefault';
import ModalSmall from '../../components/modalSmall';

export default function Users() {

   const auth = useAuth()

   const [users, setUsers] = useState([]);
   const [roles, setRoles] = useState([]);
   const [banks, setBanks] = useState([]);
   const [reports, setReports] = useState([]);
   

    const fetchData = async () => {
        try {
          const data = await axios.get(rootUrl(`/getUsers/${auth.user.cid}`));
          if (data.status === 200) {
            setUsers(data.data.data.biodata);
            
          }
        } catch (e) {
          toast.error(e?.message);
        }

        try {
          const data = await axios.get(rootUrl(`/getRoles`));
          if (data.status === 200) {
            setRoles(data.data.data);
          }
        } catch (e) {
          toast.error(e?.message);
        }

        try {
          const data = await axios.get(rootUrl(`/getBanks/${auth.user.cid}`));
          if (data.status === 200) {
            setBanks(data.data.data);
          }
        } catch (e) {
          toast.error(e?.message);
        }

        try {
          const data = await axios.get(rootUrl(`/getReports`));
          if (data.status === 200) {
            setReports(data.data.data);
          }
        } catch (e) {
          toast.error(e?.message);
        }
      };
    
      useEffect(()=>{
        fetchData()
      }, [])

      const [modal, setModal] = useState({title: '', open: false, body: '', size: 'sm'});
        
      const handleClose = () => {
        setModal({...modal, open: false });   
      };
    
      const columns = [
        { name: 'Email', selector: row => row.email, sortable: true },
        { name: 'First Name', selector: row => row.firstname +' '+row.lastname, sortable: true },
        { name: 'Phone Number', selector: row => row.phonenumber, sortable: true },
        { name: 'Date of Birth', selector: row => row.dob, sortable: true },
        { name: 'Gender', selector: row => row.sex, sortable: true },
        // { name: 'Roles', selector: row => row.rid!== null?roles?.find(a=>a.id === row.rid)?.name:'No Roles', sortable: true },
        { name: 'Status', cell:row=>row.mode == 0?'Pending':'Approved' },
        {
          name: 'Actions',
          cell: row => row.mode == 0? <button className='text-blue-500' onClick={() => handleApprove(row.u_id)}> 
          <FaThumbsUp /> </button>:
          <>
          <button className='text-blue-500 m-1' onClick={() => handleRoles(row.u_id, 1)}> <FaEdit /> </button>
          <button className='text-blue-500 m-1' onClick={() => handleRoles(row.u_id, 2)}> <FaBook /> </button>
          <button className='text-purple-500 m-1' onClick={() => handleRoles(row.u_id, 3)}> <FaChartBar /> </button>
          </>,
          button: true
        }
      ];
      const handleApprove = async (id) => {
        try {
            const data = await axios.get(rootUrl(`/approve/${id}`));
            if (data.status === 200) {
                toast.success("Successful");
                fetchData()
            }
          } catch (e) {
            toast.error(e?.message);
          }
      };

      let uid = ''
      let type = 0

      const onsubmit = async(formdata)=>{
        formdata['uid'] = uid;
        console.log(type)
        let url = ''
        if (type === 1) {
          url = 'giveUserRoles'
        } else if (type === 2) {
          url = 'giveBankUserRoles'
        } else if (type === 3) {
          url = 'giveUserReportRoles'
        }
        try {
          
          const data = await axios.post(rootUrl(`/${url}`), formdata);
          if (data.status === 200) {
              toast.success("Successful");
              fetchData()
              handleClose()
          }
        } catch (e) {
          toast.error(e?.message);
        }

      }

      function handleRoles(id, typ){
        uid = id
        type = typ
        
        let title = ''
        if (type === 1) {
          title = 'Navigation Roles'
        } else if (type === 2) {
          title = 'Bank Roles'
        } else if (type === 3) {
          title = 'Report Roles'
        }
        
        setModal({
          title: title,
          open: true,
          size: 'sm',
          body:<>  <RoleSelectionForm roles={type === 1?roles:type === 2?banks:reports} uid={id} type={type} onSubmit={onsubmit} /> </>
        });
      }

     
  
  return (
    <div>
        <DataTable
        title="User List"
        columns={columns}
        data={users}
        pagination
        highlightOnHover
        pointerOnHover
      />

      <ModalSmall title={modal.title} size={modal.size} open={modal.open} onClose={handleClose} body={modal.body} />
    </div>
  )
}



const RoleSelectionForm = ({ roles, uid, onSubmit, type }) => {
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [loading, setLoading] = useState(true);

  const getUserRoles = async () => {
    try {
      let url = ''
      if (type === 1) {
        url = 'getUserRoles'
      } else if (type === 2) {
        url = 'getUserBankRoles'
      } else if (type === 3) {
        url = 'getUserReportRoles'
      }
      const response = await axios.get(rootUrl(`/${url}/${uid}`));
      if (type === 1) {
        setSelectedRoles(response.data.data.map((a) => a.nid))
      } else if (type === 2) {
        setSelectedRoles(response.data.data.map((a) => a.bid))
      } else if (type === 3) {
        setSelectedRoles(response.data.data.map((a) => a.rid))
      }
      
    } catch (error) {
      console.error("Error fetching user roles:", error);
    } finally {
      setLoading(false); // Stop loading after fetching data
    }
  };
  useEffect(() => {
    getUserRoles();
  }, []);

  const handleRoleChange = (roleId) => {
    setSelectedRoles((prevRoles) =>
      prevRoles.includes(roleId)
        ? prevRoles.filter((id) => id !== roleId) 
        : [...prevRoles, roleId] 
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({roles:selectedRoles});
  };

  if (loading) return <FaSpinner size={50} className="spinner"  />; 

  let title = ''
  if (type === 1) {
    title = 'Select Navigation Roles'
  } else if (type === 2) {
    title = 'Select Bank Roles'
  } else if (type === 3) {
    title = 'Select Report Roles'
  }

  return (
    <form onSubmit={handleSubmit} className="p-4 border rounded-lg shadow-md">
      <h2 className="text-lg font-semibold mb-2">{title}</h2>
      <div className="space-y-2">
        {roles.map((role) => (
          <label key={role.id} className="flex items-center space-x-2">
            <input
              type="checkbox"
              value={role.id}
              checked={selectedRoles.includes(role.id)}
              onChange={() => handleRoleChange(role.id)}
              className="w-4 h-4"
            />
            <span>{type === 3?role.description:role.name}</span>
          </label>
        ))}
      </div>
      <button
        type="submit"
        className="mt-4 bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600"
      >
        Submit
      </button>
    </form>
  );
};



